module.exports = __webpack_public_path__ + "media/images/mailers/enneagram_symbol-8ec7aad28b9101bdb56703e9bd97ef22.png";